import UiLstStoreBase from '../../cls/stores/UiLstStoreBase'

/**
 * @class UiLstWorkflowsStore
 * @extends UiLstStoreBase
 * @description This class represents the store for the UI list of workflows. It extends the UiLstStoreBase class and initializes the workflows store with default filters for status, type, due date, and priority.
 */
class UiLstWorkflowsStore extends UiLstStoreBase {
	/**
	 * @constructor
	 * @param {object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of UiLstWorkflowsStore with the specified root store and initializes the store with default filters.
	 */
	constructor(rootStore) {
		// Call the parent constructor with the root store and default filters.
		super(rootStore, {
			status: '',
			workflow_type: '',
			due_date: '',
			priority: '',
			user_uid: '',
			for_user_uid: '',
			orderBy: 'id',
			orderDir: 'desc'
		})
	}
}

export default UiLstWorkflowsStore
